var _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatsBadgedInactive = function SvgChatsBadgedInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 8,
    r: 6,
    fill: props.accentFill,
    stroke: "none"
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "chats-badged-inactive_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 37
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 0H0v36.16h44V0h-8zm0 0a8 8 0 110 16 8 8 0 010-16z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#chats-badged-inactive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.8 26.523v-1h-.032l-.032.002.064.998zm-5.575-15.52A3.002 3.002 0 0117.227 8V6a5.002 5.002 0 00-5.002 5.002h2zm0 9.09v-9.09h-2v9.09h2zm0 3.803v-3.803h-2v3.803h2zm0 2.627v-2.627h-2v2.627h2zm0 1.714v-1.714h-2v1.714h2zm5.402-2.709c-2.05 0-3.472.29-4.528.728-1.07.445-1.697 1.017-2.145 1.424l1.345 1.48c.417-.378.832-.751 1.567-1.057.749-.31 1.895-.575 3.76-.575v-2zm.11-.003a1.736 1.736 0 01-.11.003v2c.08 0 .158-.002.236-.007l-.127-1.996zm9.483-.002H19.8v2h9.42v-2zm7.005-7.005a7.004 7.004 0 01-7.005 7.005v2a9.004 9.004 0 009.005-9.005h-2zm0-3.514v3.514h2v-3.514h-2zM29.22 8a7.004 7.004 0 017.005 7.004h2A9.004 9.004 0 0029.22 6v2zM17.227 8H29.22V6H17.227v2zm-5.002 20.237c0 1.04 1.24 1.681 2.074.924l-1.345-1.481c.516-.468 1.27-.051 1.27.557h-2z",
    fill: props.fill,
    stroke: "none"
  })));
};
export default SvgChatsBadgedInactive;